// src/components/Navbar.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CalendlyButton from './CalendlyButton';
import logo from '../assets/images/logo/logo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between px-4 py-3">
        {/* Logo + slogan */}
        <Link to="/" className="flex items-center gap-3">
          <img src={logo} alt="AmplifyMyCom" className="h-28 w-auto" />
          <span className="text-sm text-gray-600 hidden sm:block">
            Boostez votre impact LinkedIn
          </span>
        </Link>

        {/* Burger menu pour mobile */}
        <button
          className="md:hidden text-gray-700 focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <svg
            className="w-7 h-7"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        {/* Menu desktop */}
        <nav className="hidden md:flex gap-6 text-gray-700 font-medium">
          <Link to="/manifeste" className="hover:text-blue-600">Notre mission</Link>
          <Link to="/services" className="hover:text-blue-600">Services</Link>
          <Link to="/equipe" className="hover:text-blue-600">L’équipe</Link>
          <Link to="/tarifs" className="hover:text-blue-600">Offres</Link>
          <Link to="/contact" className="hover:text-blue-600">Contact</Link>
        </nav>

        {/* Calendly Button (desktop) */}
        <div className="hidden md:block ml-4">
          <CalendlyButton />
        </div>
      </div>

      {/* Menu mobile */}
      {menuOpen && (
        <div className="md:hidden px-4 pb-4 bg-white shadow-md">
          <nav className="flex flex-col gap-3 text-gray-700 font-medium mb-4">
            <Link to="/manifeste" onClick={() => setMenuOpen(false)}>Notre mission</Link>
            <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
            <Link to="/equipe" onClick={() => setMenuOpen(false)}>L’équipe</Link>
            <Link to="/tarifs" onClick={() => setMenuOpen(false)}>Offres</Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
          </nav>
          <div className="flex justify-center">
            <CalendlyButton />
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
